import * as zod from 'zod';

export const PalletBoxType = zod.object({
  id: zod.string(),
  name: zod.string(),
  width: zod.number(),
  height: zod.number(),
  depth: zod.number(),
  weight: zod.number(),
});

export type PalletBoxType = zod.infer<typeof PalletBoxType>;

export const PalletBoxInstance = zod.object({
  id: zod.string(),
  x: zod.number(),
  y: zod.number(),
  rotation: zod.number(),
  order: zod.number(),
  approachDirection: zod.number(),
});

export type PalletBoxInstance = zod.infer<typeof PalletBoxInstance>;

export const PalletBoxLayerPattern = zod.object({
  id: zod.string(),
  name: zod.string(),
  boxTypeID: zod.string(),
  automaticSequencing: zod.boolean(),
  globalApproachDirection: zod.number(),
  boxList: PalletBoxInstance.array(),
});

export type PalletBoxLayerPattern = zod.infer<typeof PalletBoxLayerPattern>;
